import React from 'react';
import { cn } from 'modules/Common/utils/cn';
import { clientInitials } from 'modules/Consultant/utils/clientDirectory';

// Brand-tinted initials chip identifying a client across the consultant home.
const SIZES = {
  sm: 'h-5 w-5 text-[9px] rounded',
  md: 'w-10 h-10 text-sm rounded-lg',
};

export default function ClientAvatar({ name, size = 'md' }) {
  return (
    <span
      aria-hidden="true"
      className={cn(
        'flex items-center justify-center shrink-0 font-semibold bg-primaryColor/10 text-primaryColor',
        SIZES[size],
      )}
    >
      {clientInitials(name)}
    </span>
  );
}
